import '../styles/global.scss';
import { RedbubbleApp } from '@redbubble/next/app';

export default RedbubbleApp;
